import React from 'react';
import IndustryDetail from './IndustryDetail';

const features = [
  {
    tag: 'Development',
    title: 'Custom Software',
    desc: 'Bespoke software solutions tailored to your business needs — web, mobile, and enterprise applications.',
  },
  {
    tag: 'Cloud',
    title: 'Cloud Solutions',
    desc: 'Modern cloud infrastructure, migration services, and managed cloud operations on AWS, Azure, and GCP.',
  },
  {
    tag: 'Digital',
    title: 'Digital Transformation',
    desc: 'End-to-end digital transformation consulting and implementation for traditional businesses going digital.',
  },
  {
    tag: 'Platform',
    title: 'Enterprise Platforms',
    desc: 'Ready-to-deploy enterprise platforms for ERP, CRM, HR, and supply chain management.',
  },
];

const ITSolutions: React.FC = () => (
  <IndustryDetail
    breadcrumb="IT Solutions"
    title="Ajera Infotech"
    subtitle="Scalable IT solutions for modern enterprises."
    description="Ajera Infotech provides scalable IT solutions, digital transformation services, and modern enterprise platforms. We build technology that drives growth, efficiency, and competitive advantage."
    features={features}
    accentColor="#7c3aed"
  />
);

export default ITSolutions;
